/**
 * Splits an array of items into columns based on the columnNumber property
 *
 * @example spreadIntoColumns([{ columnNumber: 1 }, { columnNumber: 2 }, { columnNumber: 1 }])
 * returns [[{ columnNumber: 1 }, { columnNumber: 1 }], [{ columnNumber: 2 }]]
 */
export function spreadIntoColumns<T extends { columnNumber: number }>(arr: T[]): T[][] {
  const maxColumns = Math.max(...arr.map((item) => item.columnNumber));
  return Array.from({ length: maxColumns }, (_, index) =>
    arr.filter((item) => item.columnNumber === index + 1),
  );
}
